import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import PageWrapper from 'templates/PageWrapper'
import BreadCrumb from 'components/atoms/BreadCrumb'
import GroupTrapMap from 'components/organisms/GroupTrapMap'
import SubmitButton from 'components/atoms//buttons/SubmitButton'

export const styles = theme => ({
  root: {
    marginTop: theme.spacing(6),
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: theme.spacing(4),
    justifyContent: 'space-between',
  },
  subtitle: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  map: {
    marginTop: theme.spacing(4),
  },
})

const ManageGroupDetails = ({ classes, group, handleEditClick }) => (
  <div className={classes.root}>
    <PageWrapper>
      <BreadCrumb
        links={[{ label: 'Groups', to: '/dashboard/manage/groups' }]}
        currentPageLabel={group.name}
      />
      <div className={classes.header}>
        <Typography variant="h1">{group.name}</Typography>
        <SubmitButton
          size="medium"
          color="primary"
          variant="primary"
          onClick={handleEditClick}>
          Edit Group
        </SubmitButton>
        <Typography className={classes.subtitle}>Group</Typography>
      </div>
    </PageWrapper>
    <div className={classes.map}>
      <GroupTrapMap />
    </div>
  </div>
)

ManageGroupDetails.propTypes = {
  group: PropTypes.object,
  classes: PropTypes.object,
  handleEditClick: PropTypes.func,
}

export default withStyles(styles)(ManageGroupDetails)



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroupDetails/ManageGroupDetails.js